import React, {useEffect} from 'react';
import {useOrganizations} from 'data/organization';
import {Building} from 'lucide-react';

const OrganizationPicker = ({organizationId, onOrganizationIdChange}) => {
	const {data: organizationsData} = useOrganizations();

	useEffect(() => {
		if (!organizationId && organizationsData?.length) {
			onOrganizationIdChange(organizationsData?.[0]?.id);
		}
	}, [organizationsData, onOrganizationIdChange, organizationId]);

	return (
		<div className="flex gap-3 items-center">
			<Building className="size-5 text-gray-400" />
			<select
				value={organizationId || ''}
				disabled
				onChange={e => onOrganizationIdChange(e.target.value || null)}
				className="border rounded-md h-8 px-2 font-medium shadow-sm disabled:bg-gray-200 disabled:shadow-none"
			>
				{(organizationsData || []).map(organization => (
					<option key={organization.id} value={organization.id}>
						{organization.title}
					</option>
				))}
			</select>
		</div>
	);
};

export default OrganizationPicker;
